// "Add to calendar" link builders. Emma datetimes are absolute ISO strings
// (e.g. 2026-06-24T07:00:00-04:00), so everything is expressed in UTC and the
// receiving calendar renders it in the user's own timezone — no timezone
// database needed client-side.

const pad = n => String(n).padStart(2, "0")

// Date -> 20260624T110000Z
function utcStamp(date) {
    return (
        date.getUTCFullYear() +
        pad(date.getUTCMonth() + 1) +
        pad(date.getUTCDate()) +
        "T" +
        pad(date.getUTCHours()) +
        pad(date.getUTCMinutes()) +
        pad(date.getUTCSeconds()) +
        "Z"
    )
}

export function googleCalendarUrl({ title, start, end, location, description }) {
    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: title,
        dates: `${utcStamp(start)}/${utcStamp(end)}`,
    })
    if (location) params.set("location", location)
    if (description) params.set("details", description)
    return `https://calendar.google.com/calendar/render?${params}`
}

export function outlookCalendarUrl({ title, start, end, location, description }) {
    const params = new URLSearchParams({
        path: "/calendar/action/compose",
        rru: "addevent",
        subject: title,
        startdt: start.toISOString(),
        enddt: end.toISOString(),
    })
    if (location) params.set("location", location)
    if (description) params.set("body", description)
    return `https://outlook.live.com/calendar/0/action/compose?${params}`
}

export function yahooCalendarUrl({ title, start, end, location, description }) {
    const params = new URLSearchParams({
        v: "60",
        title,
        st: utcStamp(start),
        et: utcStamp(end),
    })
    if (location) params.set("in_loc", location)
    if (description) params.set("desc", description)
    return `https://calendar.yahoo.com/?${params}`
}

const escapeIcsText = text => String(text).replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\r?\n/g, "\\n")

export function buildIcs({ id, title, start, end, location, description }) {
    const lines = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//CRF//Meetings//EN",
        "BEGIN:VEVENT",
        `UID:${id ?? utcStamp(start)}@crfconnect.com`,
        `DTSTAMP:${utcStamp(new Date())}`,
        `DTSTART:${utcStamp(start)}`,
        `DTEND:${utcStamp(end)}`,
        `SUMMARY:${escapeIcsText(title)}`,
    ]
    if (location) lines.push(`LOCATION:${escapeIcsText(location)}`)
    if (description) lines.push(`DESCRIPTION:${escapeIcsText(description)}`)
    lines.push("END:VEVENT", "END:VCALENDAR")
    return lines.join("\r\n")
}

// Apple Calendar / desktop Outlook path: hand the browser an .ics file.
export function downloadIcs(event) {
    const blob = new Blob([buildIcs(event)], { type: "text/calendar;charset=utf-8" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "event.ics"
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
}
